export default __webpack_public_path__ + "static/media/394159__vacuumfan7072__uiclick5.f0dca3ec.mp3";